import { request } from '@/utils/ajax';
import type {
    OptionPresetGroupDto,
    OptionPresetGroupUpdateOptions,
    OptionPresetGroupWithItemsDto,
    OptionPresetMatrixDto,
    PresetItemsChangeSet,
} from './option-preset-group.types';

export function getOptionPresetGroups(projectId: number): Promise<OptionPresetGroupDto[]> {
    return request(`api/option-preset-group?projectId=${encodeURIComponent(projectId)}`, {}).then((x) => x.json());
}
export function getOptionPresetGroupsWithItems(projectId: number): Promise<OptionPresetGroupWithItemsDto[]> {
    return request(`api/option-preset-group/with-items?projectId=${encodeURIComponent(projectId)}`, {}).then((x) => x.json());
}

export function createOptionPresetGroup(options: OptionPresetGroupUpdateOptions): Promise<OptionPresetGroupDto> {
    return request('api/option-preset-group', {
        method: 'POST',
        json: true,
        body: options,
    }).then((x) => x.json());
}

export function updateOptionPresetGroup(
    presetGroupId: number,
    options: OptionPresetGroupUpdateOptions
): Promise<OptionPresetGroupDto> {
    return request(`api/option-preset-group/${presetGroupId}`, {
        method: 'PUT',
        json: true,
        body: options,
    }).then((x) => x.json());
}

export function deleteOptionPresetGroup(presetGroupId: number): Promise<any> {
    return request(`api/option-preset-group/${presetGroupId}`, {
        method: 'DELETE',
    });
}

export function publishOptionPresetGroup(presetGroupId: number) {
    return request(`api/option-preset-group/${presetGroupId}/publish`, {
        method: 'PUT',
    });
}

export function unpublishOptionPresetGroup(presetGroupId: number) {
    return request(`api/option-preset-group/${presetGroupId}/unpublish`, {
        method: 'PUT',
    });
}

// Loads the whole style/preset matrix in one request (groups + items + presets + linkage).
export function getOptionPresetMatrix(presetGroupId: number): Promise<OptionPresetMatrixDto> {
    return request(`api/option-preset-group/${presetGroupId}/matrix`, {}).then((x) => x.json());
}

// Saves all matrix changes atomically (one transaction on the backend).
export function saveOptionPresetMatrix(presetGroupId: number, changes: PresetItemsChangeSet[]): Promise<any> {
    return request(`api/option-preset-group/${presetGroupId}/matrix`, {
        method: 'PUT',
        json: true,
        body: changes,
    });
}
